import { createBrowserRouter, RouterProvider, Navigate } from "react-router-dom";
import EventsPage from "./Events";
import RegistrationForm from "./RegistrationForm";
import SubmissionPage from "./Submission";
import Login from "./Login";
import Evaluation from "./Evaluation";
import CertificatePage from "./Certifcate";

const Routes = () => {
  const router = createBrowserRouter([
    // {
    //   element: <ProtectedRoutes />,
    //   children: [
    //     {
    //       path: "/dashboard",
    //       element: <Navigate to="/dashboard/census" />,
    //     },
    //     {
    //       path: "/dashboard/records",
    //       lazy: async () => {
    //         const Records = await import("src/pages/records");
    //         return { Component: Records.default };
    //       },
    //     },
    //   ],
    // },
    {
      path: "/ems/dashboard/events",
      element: <EventsPage />,
    },
    {
      path: "/ems/registration",
      element: <RegistrationForm />,
    },
    {
      path: "/ems/submission",
      element: <SubmissionPage />,
    },
    {
      path: "/ems/evaluation",
      element: <Evaluation />,
    },
    {
      path: "/ems/certificate",
      element: <CertificatePage />,
    },
    {
      path: "/ems/login",
      element: <Login />,
    },
    {
      path: "/*",
      element: <EventsPage />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default Routes;
